





























    
import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import {AuthService, User} from "@/services/auth.service";
import {AuthEventBus, AuthEvents} from "@/events";
import ConfigMixin from "@/mixins/ConfigMixin";

@Component({})
export default class HeaderMobile extends Mixins(ConfigMixin) {

    @Prop()
    public user!: User;

    private goHome() {
        if (this.$route.name !== 'Home') {
            this.$router.push({name: 'Home'});
        }
    }

    private getName(): string {
        return this.getConfig('NAME');
    }

    private get nameStart(): string {
        const raw = this.getName();
        const parts = raw.split(' ');
        return parts.slice(0, parts.length - 1).join(' ');
    }

    private get nameEnd(): string {
        const raw = this.getName();
        const parts = raw.split(' ');
        return parts[parts.length - 1];
    }

    private async logout() {
        this.$emit('logout');
    }
}

